import { FC, useCallback } from 'react';
import { Box, Checkbox, IconButton, Typography } from '@mui/material';
import { FlattenedItem, RepoNode } from '../../onboarding-types';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import {
  toggleExpand,
  toggleSelection,
} from '../../actions/onboarding-repo-selection-actions';

const RepoSelectionRow: FC<React.PropsWithChildren<RepoSelectionRowProps>> = ({
  id,
  expanded,
  selected,
  name,
  deepness,
  children,
  isIndeterminate,
}) => {
  const onChange = useCallback(() => {
    toggleSelection(id, !selected, children as RepoNode[]);
  }, [children, id, selected]);
  const onExpand = useCallback(() => {
    toggleExpand(id);
  }, [id]);
  const hasChildren = !!children?.length;
  return (
    <Box
      paddingLeft={hasChildren ? 0 : 3}
      marginLeft={deepness * 2}
      display='flex'
      flexDirection='row'
      gap={0.5}
      alignItems='center'>
      {hasChildren && (
        <IconButton size='small' onClick={onExpand}>
          {expanded ? <MdExpandLess /> : <MdExpandMore />}
        </IconButton>
      )}
      <Checkbox
        indeterminate={isIndeterminate}
        checked={selected}
        onChange={onChange}
      />
      <Typography variant='body2' color='text.primary'>
        {name}
      </Typography>
    </Box>
  );
};

export interface RepoSelectionRowProps extends FlattenedItem {}

export default RepoSelectionRow;
